module.exports = __webpack_public_path__ + "34736292/img/question-icon.06c20c5d.svg";